import { createFileRoute, Outlet, redirect } from "@tanstack/react-router";
import type { CustomerDto } from "@yalana/contracts";
import { documentTypesQueries } from "../../../features/fsm-admin/document-types/api/document-types.queries";
import { RouteError } from "../../../shared/components/RouteError";

export const Route = createFileRoute("/app/c/$customerSlug/d/$docTypeSlug")({
  errorComponent: ({ error }) => <RouteError error={error} />,
  beforeLoad: async ({ params, context }) => {
    const auth = context.auth;
    if (!auth.loading && !auth.user) {
      throw redirect({ to: "/login" });
    }
    if (auth.user) {
      const customer =
        "customer" in context
          ? (context as { customer: CustomerDto }).customer
          : null;

      const docTypes = await context.queryClient.ensureQueryData(
        documentTypesQueries.forUser(customer?.id),
      );
      // `forUser(customer?.id)` already server-side-scopes docTypes to
      // customer.id when resolved; `!customer` only occurs before customer
      // context is available.
      const docType = docTypes.find(
        (dt) =>
          dt.slug === params.docTypeSlug &&
          // authz-or-negation-ok: no cross-customer leak, see comment above.
          (!customer || dt.customerId === customer.id),
      );
      if (!docType) {
        throw redirect({
          to: "/app/c/$customerSlug",
          params: { customerSlug: params.customerSlug },
        });
      }
      return { docType };
    }
  },
  component: () => <Outlet />,
});
